import { render, staticRenderFns } from "./theHighestExpenses.vue?vue&type=template&id=730f4b36"
import script from "./theHighestExpenses.vue?vue&type=script&lang=js"
export * from "./theHighestExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports